import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "geo-start"
};
const _hoisted_2 = {
  key: 0,
  class: "info-row"
};
const _hoisted_3 = {
  key: 1,
  class: "info-row"
};
const _hoisted_4 = {
  key: 2,
  class: "info-row create-time"
};
import { ref, onMounted, computed } from 'vue';
import dayjs from 'dayjs';
import useMainStore from '@views/main/main.store';
export default /*@__PURE__*/_defineComponent({
  __name: 'GeoStart',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const mainStore = useMainStore();
    const info = ref({});
    const websiteUrl = computed(() => {
      return info.value.websiteInfo || info.value.url || '';
    });
    const createTime = computed(() => {
      const t = props.item?.msgCreateTime;
      if (!t) return '';
      return dayjs(parseInt(t, 10)).format('YYYY-MM-DD HH:mm:ss');
    });
    onMounted(() => {
      try {
        if (typeof props.content === 'string') {
          info.value = JSON.parse(props.content);
        } else if (props.content?.text) {
          info.value = typeof props.content.text === 'string' ? JSON.parse(props.content.text) : props.content.text;
        } else {
          info.value = props.content || {};
        }
      } catch {
        info.value = props.content || {};
      }
      if (props.item?.openAnimate) {
        mainStore.loadNextMsg(props.item);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [websiteUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[0] || (_cache[0] = _createTextVNode(" 正在对 ", -1)), _createVNode(_component_el_link, {
        class: "url-link",
        type: "primary",
        href: websiteUrl.value,
        target: "_blank"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(websiteUrl.value), 1)]),
        _: 1
      }, 8, ["href"]), _cache[1] || (_cache[1] = _createTextVNode(" 进行 AI 可见性检测 ", -1))])) : _createCommentVNode("", true), info.value.text && !websiteUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(info.value.text), 1)) : _createCommentVNode("", true), createTime.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, "任务创建于 " + _toDisplayString(createTime.value), 1)) : _createCommentVNode("", true)]);
    };
  }
});